import { AsyncPipe, TitleCasePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  input,
  output,
  inject,
} from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import {
  ClientSubscriptionService,
  ToastMessageService,
  SubscriptionService,
  TenantService,
} from '@fitness-force/api';
import { BillingAddOnComponent } from '@fitness-force/billing';
import {
  NotificationChannels,
  PlanCategory,
  SubscriptionStatus,
  TrackMode,
} from '@fitness-force/enum';
import { AppErrors } from '@fitness-force/models';
import { ErrorMsgComponent } from '@fitness-force/errors';
import type {
  InvoiceOccurance,
  PlanAddons,
  SubscriptionById,
  voidSubscriptionRequest,
} from '@fitness-force/models';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SubscriptionCancelComponent } from '../client-profile/subscription-tab/subscription-cancel/subscription-cancel.component';
import { SubscriptionFreeDiscountComponent } from '../client-profile/subscription-tab/subscription-free-discount/subscription-free-discount.component';
import { SubscriptionPatchComponent } from '../client-profile/subscription-tab/subscription-patch/subscription-patch.component';
import { DialogModule } from 'primeng/dialog';
import { MessageModule } from 'primeng/message';

import { ButtonModule } from 'primeng/button';

import { RippleModule } from 'primeng/ripple';
import { StyleClassModule } from 'primeng/styleclass';
import {
  FeatureFlagService,
  RouteStateService,
} from '@fitness-force/shared-utils';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { PopoverModule } from 'primeng/popover';
import { ConfirmationService } from 'primeng/api';
import { MiniSearchComponent } from '@fitness-force/common/search';
import { AvatarModule } from 'primeng/avatar';

@Component({
  selector: 'subscription-action-list',
  templateUrl: './subscription-action-list.component.html',
  styleUrls: ['./subscription-action-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormsModule,
    SubscriptionFreeDiscountComponent,
    BillingAddOnComponent,
    SubscriptionCancelComponent,
    SubscriptionPatchComponent,
    DialogModule,
    MessageModule,
    ButtonModule,
    RippleModule,
    StyleClassModule,
    ConfirmPopupModule,
    ErrorMsgComponent,
    PopoverModule,
    TranslateModule,
    MiniSearchComponent,
    AvatarModule,
    AsyncPipe,
    TitleCasePipe,
  ],
})
export class SubscriptionActionListComponent implements OnInit, OnDestroy {
  private readonly toastMessageService = inject(ToastMessageService);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  private readonly translate = inject(TranslateService);
  private readonly subscriptionService = inject(SubscriptionService);
  private readonly fb = inject(UntypedFormBuilder);
  private readonly confirmationService = inject(ConfirmationService);
  private readonly clientSubscriptionService = inject(
    ClientSubscriptionService,
  );
  private readonly router = inject(Router);
  private readonly tenantService = inject(TenantService);
  private readonly routeStateService = inject(RouteStateService);
  private readonly featureFlagService = inject(FeatureFlagService);

  readonly clientId = input<number>(0);
  readonly tenantId = input<number>(0);
  readonly subscriptionId = input<number>(0);
  private readonly destroy$ = new Subject<void>();
  readonly signupId = input<number>(0);
  readonly subscription = input<SubscriptionById>();

  localSubscriptionId: number = 0;
  localSubscription: SubscriptionById | null = null;
  localPlanId: number = 0;
  readonly signupData = input<any>(null);
  readonly showFreeDiscount = input<boolean>(false);
  readonly paymentTimelineData = input(
    new BehaviorSubject<InvoiceOccurance[]>([]),
  );
  readonly trackMode = input<TrackMode>(TrackMode.StaffWebApp);
  readonly class = input<string>(
    'absolute right-0 top-0 mt-2 mr-2 flex align-items-center justify-content-end',
  );
  readonly closeAddonEvent = output<{
    event: any;
    subscription: any;
  }>();
  readonly emitEvents = output<any>();

  btnLoading: boolean = false;
  reloadData: boolean = false;
  showSkeleton$ = new BehaviorSubject<boolean>(true);
  getAccessTenantList$: any;
  allTenants: any;
  voidSubscriptionForm: UntypedFormGroup = new UntypedFormGroup({});
  ActivateMebershipForm: UntypedFormGroup = new UntypedFormGroup({});
  VoidSubscriptionSignupForm: UntypedFormGroup = new UntypedFormGroup({});
  signUpDetails: any;
  showVoidSubscriptionModal: boolean = false;
  upgradedSubscription: boolean = false;
  btnLoading$ = new BehaviorSubject<boolean>(false);

  ActivateMembershipPopup: boolean = false;
  activateMembership: boolean = false;

  showFreeDiscountApply = new BehaviorSubject(false);
  clientDetails: any;
  addDiscountedPeriod: boolean = false;
  showAddonSidebar: boolean = false;
  planId: number = 0;
  selectedAddons = new BehaviorSubject<PlanAddons[]>([]);
  showCancelSubscription: boolean = false;
  clientSubscriptionData = new BehaviorSubject<any>({});

  showTransfer = new BehaviorSubject(false);
  showSubscriptionAmendment = new BehaviorSubject(false);
  showSubscriptionStatusOverride = new BehaviorSubject(false);
  showStopBilling = new BehaviorSubject(false);
  voidSignUpBtnLoading: boolean = false;
  voidSignUpPopup: boolean = false;
  showAddonBilling = new BehaviorSubject(false);

  sendLinkCollectDues: boolean = false;
  emailSelected: boolean = false;
  smsSelected: boolean = false;
  whatsappSelected: boolean = false;
  mobileNotificationSelected: boolean = false;
  isPresaleTenant: boolean = false;

  // Add Member to Subscription properties
  showAddMemberModal: boolean = false;
  selectedFamilyMember: any = null;
  addMemberLoading: boolean = false;
  addMemberForm: UntypedFormGroup = new UntypedFormGroup({});
  stopBillingForm: UntypedFormGroup = new UntypedFormGroup({});
  resumeBillingForm: UntypedFormGroup = new UntypedFormGroup({});
  showStopBillingModal = false;
  showResumeBillingModal = false;
  showForceStatusModal = false;
  showClearOverrideModal = false;
  stopBillingBtnLoading = false;
  resumeBillingBtnLoading = false;
  forceStatusBtnLoading = false;
  clearOverrideBtnLoading = false;
  pendingForceStatus: 'Active' | 'SuspendedDueToNonPayment' | null = null;
  showPatchSubscriptionModal = false;
  forceStatusForm: UntypedFormGroup = new UntypedFormGroup({});
  clearOverrideForm: UntypedFormGroup = new UntypedFormGroup({});

  constructor() {
    this.isPresaleTenant = this.tenantService.IsPresaleTenant();
  }

  ngOnInit(): void {
    this.clientSubscriptionData.next(this.subscription());

    // Use getFlag$() observable to wait for Statsig initialization
    this.featureFlagService
      .getFlag$('show_add_discount_on_billing_cycle')
      .pipe(takeUntil(this.destroy$))
      .subscribe((isEnabled) => {
        this.showFreeDiscountApply.next(isEnabled);
      });

    this.featureFlagService
      .getFlag$('show_transfer')
      .pipe(takeUntil(this.destroy$))
      .subscribe((isEnabled) => {
        this.showTransfer.next(isEnabled);
      });

    this.featureFlagService
      .getFlag$('show_subscription_amendment')
      .pipe(takeUntil(this.destroy$))
      .subscribe((isEnabled) => {
        this.showSubscriptionAmendment.next(isEnabled);
        this.changeDetectorRef.markForCheck();
      });

    this.featureFlagService
      .getFlag$('show_addons_billing')
      .pipe(takeUntil(this.destroy$))
      .subscribe((isEnabled) => {
        this.showAddonBilling.next(isEnabled);
      });

    this.featureFlagService
      .getFlag$('show_subscription_status_override')
      .pipe(takeUntil(this.destroy$))
      .subscribe((isEnabled) => {
        this.showSubscriptionStatusOverride.next(isEnabled);
        this.changeDetectorRef.markForCheck();
      });

    this.featureFlagService
      .getFlag$('show_stop_billing')
      .pipe(takeUntil(this.destroy$))
      .subscribe((isEnabled) => {
        this.showStopBilling.next(isEnabled);
        this.changeDetectorRef.markForCheck();
      });

    this.voidSubscriptionForm = this.fb.group({
      void_reason: ['', [Validators.required]],
    });

    this.ActivateMebershipForm = this.fb.group({
      change_reason: ['', [Validators.required]],
    });

    this.VoidSubscriptionSignupForm = this.fb.group({
      void_reasons: ['', [Validators.required]],
    });

    this.addMemberForm = this.fb.group({
      member_id: ['', [Validators.required]],
    });

    this.stopBillingForm = this.fb.group({
      stop_billing_reason: ['', [Validators.required]],
    });

    this.resumeBillingForm = this.fb.group({
      resume_billing_reason: ['', [Validators.required]],
    });

    this.forceStatusForm = this.fb.group({
      status_change_reason: ['', [Validators.required]],
    });

    this.clearOverrideForm = this.fb.group({
      override_change_reason: ['', [Validators.required]],
    });

    this.changeDetectorRef.detectChanges();
  }

  showVoidSubscription(subscription: any) {
    this.localSubscription = subscription;
    this.showVoidSubscriptionModal = true;
    if (
      subscription.upgrade_from_clt_subs_id &&
      subscription.upgrade_from_clt_subs_id > 0
    )
      this.upgradedSubscription = true;
    else this.upgradedSubscription = false;
  }

  voidSubscription(form: UntypedFormGroup) {
    this.btnLoading$.next(true);
    if (form.valid) {
      const voidRequest: voidSubscriptionRequest =
        {} as voidSubscriptionRequest;
      voidRequest.void_reason = form.value.void_reason;
      let service: any;
      const subscription = this.subscription();
      if (subscription) {
        if (this.upgradedSubscription) {
          service = this.subscriptionService.VoidUpgradeSubscription(
            subscription.tenant_id,
            this.clientId(),
            subscription.id,
            voidRequest,
          );
        } else {
          service = this.subscriptionService.VoidSubscription(
            subscription.tenant_id,
            this.clientId(),
            subscription.id,
            voidRequest,
          );
        }
      }
      service.subscribe({
        next: () => {
          this.translate
            .get('SUBSCRIPTIONS.MSG.SUBSCRIPTION_VOID_MSG')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          this.voidSubscriptionForm.reset();
          this.btnLoading$.next(false);
          this.showVoidSubscriptionModal = false;
          this.emitEvents.emit(true);
          //this.componentInit();
        },
        error: (error: AppErrors) => {
          this.btnLoading$.next(false);
          this.toastMessageService.showError(error);
        },
      });
    } else {
      Object.keys(this.voidSubscriptionForm.controls).forEach((field) => {
        const control = this.voidSubscriptionForm.get(field);
        control?.markAsTouched({ onlySelf: true });
      });
      this.btnLoading$.next(false);
    }
  }

  showActiveMembershipBtn(status: string) {
    const subscrptionStatus =
      SubscriptionStatus[status as keyof typeof SubscriptionStatus];
    return subscrptionStatus == SubscriptionStatus.PendingForMandatoryAction;
  }

  ShowActivateMembership(subscription: any) {
    this.localSubscription = subscription;
    this.activateMembership = true;
    this.ActivateMembershipPopup = true;
  }

  CanAddFreeDiscount(status: string) {
    const subscrptionStatus =
      SubscriptionStatus[status as keyof typeof SubscriptionStatus];
    return (
      subscrptionStatus == SubscriptionStatus.Active ||
      subscrptionStatus == SubscriptionStatus.Frozen ||
      subscrptionStatus == SubscriptionStatus.NotRenewing ||
      subscrptionStatus == SubscriptionStatus.Future
    );
  }

  IsSubscrptionVoidOrCancelled(status: string) {
    const subscrptionStatus =
      SubscriptionStatus[status as keyof typeof SubscriptionStatus];
    return (
      subscrptionStatus == SubscriptionStatus.Void ||
      subscrptionStatus == SubscriptionStatus.Cancelled ||
      subscrptionStatus == SubscriptionStatus.Upgraded
    );
  }

  IsSubscrptionManageLinkValid(status: string) {
    const subscrptionStatus =
      SubscriptionStatus[status as keyof typeof SubscriptionStatus];
    return (
      subscrptionStatus == SubscriptionStatus.Future ||
      subscrptionStatus == SubscriptionStatus.Active ||
      subscrptionStatus == SubscriptionStatus.Frozen ||
      subscrptionStatus == SubscriptionStatus.SuspendedDueToNonPayment ||
      subscrptionStatus == SubscriptionStatus.PendingForMandatoryAction ||
      subscrptionStatus == SubscriptionStatus.PendingForPaymentConfirmation
    );
  }

  showFreeDiscountSection(ss: any) {
    this.clientDetails = {
      client_id: this.clientId(),
      name: 'test',
      image: '',
    };
    this.addDiscountedPeriod = true;
    this.localSubscriptionId = ss.id;
  }

  closeFreeDiscountPopup(event: any) {
    this.addDiscountedPeriod = false;
    this.emitEvents.emit(event);
  }

  ShowMidCycleAddon() {
    const subscription = this.subscription();
    this.localPlanId = subscription?.plan_id || 0;
    this.showAddonSidebar = true;
  }

  closeAddonSidebar(event: any) {
    this.showAddonSidebar = false;
    this.closeAddonEvent.emit({
      event: event,
      subscription: this.subscription(),
    });
  }

  isNotRenewingStatus(status: string) {
    const subscrptionStatus =
      SubscriptionStatus[status as keyof typeof SubscriptionStatus];
    return subscrptionStatus == SubscriptionStatus.NotRenewing;
  }

  ReActivateMembership(subscription: any) {
    this.localSubscription = subscription;
    this.activateMembership = false;
    this.ActivateMembershipPopup = true;
  }

  VoidSignUp() {
    this.voidSignUpBtnLoading = true;
    this.signUpDetails = this.subscription();
    this.voidSignUpPopup = true;
  }

  SubmitVoidSignup(event: Event) {
    if (this.VoidSubscriptionSignupForm.valid) {
      let translation: any;
      this.translate
        .get([
          'BILL_OWNER_CHANGE.CHANGE_INFO',
          'common.BUTTONS.BUTTON-TEXT-YES',
          'common.BUTTONS.BUTTON-TEXT-NO',
        ])
        .subscribe((translations) => {
          translation = translations;
        });
      this.confirmationService.confirm({
        target: event.target as EventTarget,
        key: 'activatemembership',
        message: 'Are you sure that you want to proceed?',
        icon: 'fa fa-exclamation-triangle',
        acceptLabel: translation['common.BUTTONS.BUTTON-TEXT-YES'],
        rejectLabel: translation['common.BUTTONS.BUTTON-TEXT-NO'],
        accept: () => {
          const changeRequest: any = {} as any;
          changeRequest.void_reasons =
            this.VoidSubscriptionSignupForm.value.void_reasons;

          // Use signup data if available, otherwise fall back to component inputs
          const tenantIdToUse = this.signupData()?.tenant_id || this.tenantId();
          const signupIdToUse = this.signupData()?.id || this.signupId();

          this.subscriptionService
            .VoidSignUp(
              tenantIdToUse,
              this.clientId(),
              signupIdToUse,
              changeRequest,
            )
            .subscribe({
              next: () => {
                this.translate
                  .get('SUBSCRIPTIONS.MSG.SIGNUP_VOID_MSG')
                  .subscribe((translation) => {
                    this.toastMessageService.showSuccess(translation);
                  });
                this.voidSignUpBtnLoading = false;
                this.voidSignUpPopup = false;
                this.VoidSubscriptionSignupForm.reset();
                this.emitEvents.emit(true);
              },
              error: (error) => {
                this.voidSignUpBtnLoading = false;
                if (error.originalError.status == 200) {
                  this.translate
                    .get('SUBSCRIPTIONS.MSG.SIGNUP_VOID_MSG')
                    .subscribe((translation) => {
                      this.toastMessageService.showSuccess(translation);
                    });
                  this.voidSignUpPopup = false;
                } else {
                  // Extract and display the actual API error message
                  if (error.originalError?.error?.errorMessage) {
                    this.toastMessageService.showErrorMessage(
                      error.originalError.error.errorMessage,
                    );
                  } else if (
                    error.originalError?.error &&
                    typeof error.originalError.error === 'string'
                  ) {
                    this.toastMessageService.showErrorMessage(
                      error.originalError.error,
                    );
                  } else {
                    this.toastMessageService.showError(error);
                  }
                  this.voidSignUpPopup = false;
                }
              },
            });
        },
        reject: () => {
          this.voidSignUpPopup = false;
          this.voidSignUpBtnLoading = false;
          this.VoidSubscriptionSignupForm.reset();
        },
      });
    } else {
      Object.keys(this.VoidSubscriptionSignupForm.controls).forEach((field) => {
        const control = this.VoidSubscriptionSignupForm.get(field);
        control?.markAsTouched({ onlySelf: true });
      });
    }
  }

  handleError(error: any) {
    this.toastMessageService.showError(error);
  }

  ShowToastErrors(error: any) {
    this.toastMessageService.showError(error);
  }

  getEventData(event: any) {
    if (event) this.reloadData = true;
  }

  ActivateConfirm(event: Event) {
    if (this.ActivateMebershipForm.valid) {
      let translation: any;
      this.translate
        .get([
          'BILL_OWNER_CHANGE.CHANGE_INFO',
          'common.BUTTONS.BUTTON-TEXT-YES',
          'common.BUTTONS.BUTTON-TEXT-NO',
        ])
        .subscribe((translations) => {
          translation = translations;
        });
      this.confirmationService.confirm({
        target: event.target as EventTarget,
        key: 'activatemembership',
        message: 'Are you sure that you want to proceed?',
        icon: 'fa fa-exclamation-triangle',
        acceptLabel: translation['common.BUTTONS.BUTTON-TEXT-YES'],
        rejectLabel: translation['common.BUTTONS.BUTTON-TEXT-NO'],
        accept: () => {
          const changeRequest: any = {} as any;
          changeRequest.change_reason =
            this.ActivateMebershipForm.value.change_reason;
          let service: any;
          const subscription = this.subscription();
          if (subscription) {
            if (this.activateMembership)
              service = this.clientSubscriptionService.ActivateMembership(
                subscription.tenant_id,
                this.clientId(),
                subscription.id,
                changeRequest,
              );
            else
              service = this.clientSubscriptionService.ReActivateMembership(
                subscription.tenant_id,
                this.clientId(),
                subscription.id,
                changeRequest,
              );
          }
          service.subscribe({
            next: () => {
              this.translate
                .get('SUBSCRIPTIONS.MSG.SUBSCRIPTION_ACTIVE_MSG')
                .subscribe((translation) => {
                  this.toastMessageService.showSuccess(translation);
                });
              this.ActivateMebershipForm.reset();
              this.ActivateMembershipPopup = false;
              this.emitEvents.emit(true);
              //this.componentInit();
            },
            error: (error: AppErrors) => {
              this.toastMessageService.showError(error);
            },
          });
        },
        reject: () => {
          this.ActivateMembershipPopup = false;
        },
      });
    } else {
      Object.keys(this.ActivateMebershipForm.controls).forEach((field) => {
        const control = this.ActivateMebershipForm.get(field);
        control?.markAsTouched({ onlySelf: true });
      });
    }
  }

  isMinimumDateTimeValue(eta: Date): boolean {
    return (
      new Date(eta).getTime() === new Date('0001-01-01T00:00:00').getTime()
    );
  }

  GoToCancel(subscription: any) {
    this.showCancelSubscription = true;
  }

  closeSubscriptionCancelEvent(event: {
    reloadData: boolean;
    subscription: any;
  }) {
    this.showCancelSubscription = false;
    this.clientSubscriptionData.next(event.subscription);
    this.emitEvents.emit(event.reloadData);
  }

  goToUpgrade() {
    this.router.navigate(['/client-management/upgrade', this.clientId()]);
    this.routeStateService.closeClientSidebar(true);
    this.routeStateService.setCloseOmniSearchSidebarAll(true);
  }

  goToAmendment(): void {
    const subscription = this.subscription();
    this.router.navigate([
      '/client-management/subscription-amendment',
      this.clientId(),
      subscription?.id,
    ]);
    this.routeStateService.closeClientSidebar(true);
    this.routeStateService.setCloseOmniSearchSidebarAll(true);
  }

  canAmendSubscription(subscription: SubscriptionById | null | undefined): boolean {
    if (!subscription || this.isPresaleTenant) {
      return false;
    }
    if (this.IsSubscrptionVoidOrCancelled(subscription.status)) {
      return false;
    }
    const status = subscription.status;
    return (
      status === SubscriptionStatus.Active.toString() ||
      status === SubscriptionStatus[SubscriptionStatus.Active] ||
      status === SubscriptionStatus.Future.toString() ||
      status === SubscriptionStatus[SubscriptionStatus.Future]
    );
  }

  goToTransfer() {
    this.router.navigate([
      '/client-management/client-transfer/create',
      this.clientId(),
    ]);
    this.routeStateService.closeClientSidebar(true);
    this.routeStateService.setCloseOmniSearchSidebarAll(true);
  }

  goToFreeze() {
    //this.router.navigate(['/client-management/freeze', this.clientId]);
    this.router.navigate(
      ['/client-management/freeze/apply-freeze', this.clientId()],
      {
        queryParams: { mode: 'freeze' },
      },
    );
    this.routeStateService.closeClientSidebar(true);
    this.routeStateService.setCloseOmniSearchSidebarAll(true);
  }

  get VoidReasonFormControl(): UntypedFormControl {
    return this.voidSubscriptionForm.controls.void_reason as UntypedFormControl;
  }

  get ChangeReasonActiveFormControl(): UntypedFormControl {
    return this.ActivateMebershipForm.controls
      .change_reason as UntypedFormControl;
  }

  get VoidSignupReasonFormControl(): UntypedFormControl {
    return this.VoidSubscriptionSignupForm.controls
      .void_reasons as UntypedFormControl;
  }

  get isRecurring(): boolean {
    const subscription = this.subscription();
    if (!subscription) return false;
    return (
      subscription.subscription_category &&
      (subscription.subscription_category == PlanCategory.Contract ||
        subscription.subscription_category.toString() ==
          PlanCategory[PlanCategory.Contract] ||
        subscription.subscription_category == PlanCategory.PayAsYouGo ||
        subscription.subscription_category.toString() ==
          PlanCategory[PlanCategory.PayAsYouGo])
    );
  }

  isRecurringSubscription(
    subscription: SubscriptionById | null | undefined,
  ): boolean {
    if (!subscription) return false;
    return (
      subscription.subscription_category == PlanCategory.Contract ||
      subscription.subscription_category?.toString() ==
        PlanCategory[PlanCategory.Contract] ||
      subscription.subscription_category == PlanCategory.PayAsYouGo ||
      subscription.subscription_category?.toString() ==
        PlanCategory[PlanCategory.PayAsYouGo]
    );
  }

  /** API returns stop_billing: true when billing is stopped */
  isBillingStopped(subscription: SubscriptionById | null | undefined): boolean {
    return subscription?.stop_billing === true;
  }

  /** API returns stop_billing: false when billing is active — show Stop Billing */
  canShowStopBilling(subscription: SubscriptionById | null | undefined): boolean {
    if (!this.showStopBilling.value) {
      return false;
    }
    if (!subscription || !this.isRecurringSubscription(subscription)) {
      return false;
    }
    return (
      subscription.stop_billing === false &&
      !this.IsSubscrptionVoidOrCancelled(subscription.status)
    );
  }

  /** API returns stop_billing: true when billing is stopped — show Resume Billing */
  canShowResumeBilling(subscription: SubscriptionById | null | undefined): boolean {
    if (!this.showStopBilling.value) {
      return false;
    }
    if (!subscription || !this.isRecurringSubscription(subscription)) {
      return false;
    }
    return (
      subscription.stop_billing === true &&
      !this.IsSubscrptionVoidOrCancelled(subscription.status)
    );
  }

  openStopBillingModal(): void {
    this.stopBillingForm.reset();
    this.showStopBillingModal = true;
    this.changeDetectorRef.detectChanges();
  }

  openResumeBillingModal(): void {
    this.resumeBillingForm.reset();
    this.showResumeBillingModal = true;
    this.changeDetectorRef.detectChanges();
  }

  closeStopBillingModal(): void {
    this.showStopBillingModal = false;
    this.stopBillingBtnLoading = false;
    this.stopBillingForm.reset();
    this.changeDetectorRef.detectChanges();
  }

  closeResumeBillingModal(): void {
    this.showResumeBillingModal = false;
    this.resumeBillingBtnLoading = false;
    this.resumeBillingForm.reset();
    this.changeDetectorRef.detectChanges();
  }

  submitStopBilling(): void {
    if (!this.stopBillingForm.valid) {
      Object.keys(this.stopBillingForm.controls).forEach((field) => {
        this.stopBillingForm.get(field)?.markAsTouched({ onlySelf: true });
      });
      return;
    }
    const subscription = this.subscription();
    if (!subscription) return;

    this.stopBillingBtnLoading = true;
    this.subscriptionService
      .stopBilling(this.clientId(), subscription.id, {
        stop_billing: true,
        stop_billing_reason: this.stopBillingForm.value.stop_billing_reason,
      })
      .subscribe({
        next: () => {
          this.translate
            .get('SUBSCRIPTIONS.MSG_STOP_BILLING_SUCCESS')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          this.stopBillingBtnLoading = false;
          this.closeStopBillingModal();
          this.emitEvents.emit(true);
          this.changeDetectorRef.detectChanges();
        },
        error: (error: AppErrors) => {
          this.stopBillingBtnLoading = false;
          this.toastMessageService.showError(error);
          this.changeDetectorRef.detectChanges();
        },
      });
  }

  submitResumeBilling(): void {
    if (!this.resumeBillingForm.valid) {
      Object.keys(this.resumeBillingForm.controls).forEach((field) => {
        this.resumeBillingForm.get(field)?.markAsTouched({ onlySelf: true });
      });
      return;
    }
    const subscription = this.subscription();
    if (!subscription) return;

    this.resumeBillingBtnLoading = true;
    this.subscriptionService
      .resumeBilling(this.clientId(), subscription.id, {
        resume_billing_reason:
          this.resumeBillingForm.value.resume_billing_reason,
      })
      .subscribe({
        next: () => {
          this.translate
            .get('SUBSCRIPTIONS.MSG_RESUME_BILLING_SUCCESS')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          this.resumeBillingBtnLoading = false;
          this.closeResumeBillingModal();
          this.emitEvents.emit(true);
          this.changeDetectorRef.detectChanges();
        },
        error: (error: AppErrors) => {
          this.resumeBillingBtnLoading = false;
          this.toastMessageService.showError(error);
          this.changeDetectorRef.detectChanges();
        },
      });
  }

  get StopBillingReasonFormControl(): UntypedFormControl {
    return this.stopBillingForm.controls
      .stop_billing_reason as UntypedFormControl;
  }

  get ResumeBillingReasonFormControl(): UntypedFormControl {
    return this.resumeBillingForm.controls
      .resume_billing_reason as UntypedFormControl;
  }

  private normalizeSubscriptionStatus(status?: string): string {
    if (!status) {
      return '';
    }
    return status.trim().toLowerCase().replace(/[\s_-]/g, '');
  }

  canForceSuspend(subscription: SubscriptionById | null | undefined): boolean {
    if (!this.showSubscriptionStatusOverride.value) {
      return false;
    }
    if (!subscription || !this.isRecurringSubscription(subscription)) {
      return false;
    }
    if (this.IsSubscrptionVoidOrCancelled(subscription.status)) {
      return false;
    }
    const normalized = this.normalizeSubscriptionStatus(subscription.status);
    return (
      normalized === 'active' ||
      normalized === 'future' ||
      normalized === 'frozen'
    );
  }

  canForceActivate(subscription: SubscriptionById | null | undefined): boolean {
    if (!this.showSubscriptionStatusOverride.value) {
      return false;
    }
    if (!subscription || !this.isRecurringSubscription(subscription)) {
      return false;
    }
    return (
      this.normalizeSubscriptionStatus(subscription.status) ===
      'suspendedduetononpayment'
    );
  }

  canClearOverride(subscription: SubscriptionById | null | undefined): boolean {
    if (!this.showSubscriptionStatusOverride.value) {
      return false;
    }
    return subscription?.is_status_overridden === true;
  }

  openForceSuspendModal(): void {
    this.pendingForceStatus = 'SuspendedDueToNonPayment';
    this.forceStatusForm.reset();
    this.showForceStatusModal = true;
    this.changeDetectorRef.detectChanges();
  }

  openForceActivateModal(): void {
    this.pendingForceStatus = 'Active';
    this.forceStatusForm.reset();
    this.showForceStatusModal = true;
    this.changeDetectorRef.detectChanges();
  }

  openClearOverrideModal(): void {
    this.clearOverrideForm.reset();
    this.showClearOverrideModal = true;
    this.changeDetectorRef.detectChanges();
  }

  closeForceStatusModal(): void {
    this.showForceStatusModal = false;
    this.forceStatusBtnLoading = false;
    this.pendingForceStatus = null;
    this.forceStatusForm.reset();
    this.changeDetectorRef.detectChanges();
  }

  closeClearOverrideModal(): void {
    this.showClearOverrideModal = false;
    this.clearOverrideBtnLoading = false;
    this.clearOverrideForm.reset();
    this.changeDetectorRef.detectChanges();
  }

  submitForceStatus(): void {
    if (!this.forceStatusForm.valid) {
      Object.keys(this.forceStatusForm.controls).forEach((field) => {
        this.forceStatusForm.get(field)?.markAsTouched({ onlySelf: true });
      });
      return;
    }
    const subscription = this.subscription();
    if (!subscription || !this.pendingForceStatus) {
      return;
    }

    this.forceStatusBtnLoading = true;
    this.subscriptionService
      .forceSubscriptionStatus(
        this.clientId(),
        subscription.id,
        this.pendingForceStatus,
        this.forceStatusForm.value.status_change_reason,
      )
      .subscribe({
        next: () => {
          const messageKey =
            this.pendingForceStatus === 'SuspendedDueToNonPayment'
              ? 'SUBSCRIPTIONS.MSG_FORCE_SUSPEND_SUCCESS'
              : 'SUBSCRIPTIONS.MSG_FORCE_ACTIVATE_SUCCESS';
          this.translate
            .get(messageKey)
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          this.forceStatusBtnLoading = false;
          this.closeForceStatusModal();
          this.emitEvents.emit(true);
          this.changeDetectorRef.detectChanges();
        },
        error: (error: AppErrors) => {
          this.forceStatusBtnLoading = false;
          this.toastMessageService.showError(error);
          this.changeDetectorRef.detectChanges();
        },
      });
  }

  submitClearOverride(): void {
    if (!this.clearOverrideForm.valid) {
      Object.keys(this.clearOverrideForm.controls).forEach((field) => {
        this.clearOverrideForm.get(field)?.markAsTouched({ onlySelf: true });
      });
      return;
    }
    const subscription = this.subscription();
    if (!subscription) {
      return;
    }

    this.clearOverrideBtnLoading = true;
    this.subscriptionService
      .clearStatusOverride(
        this.clientId(),
        subscription.id,
        this.clearOverrideForm.value.override_change_reason,
      )
      .subscribe({
        next: () => {
          this.translate
            .get('SUBSCRIPTIONS.MSG_CLEAR_OVERRIDE_SUCCESS')
            .subscribe((translation) => {
              this.toastMessageService.showSuccess(translation);
            });
          this.clearOverrideBtnLoading = false;
          this.closeClearOverrideModal();
          this.emitEvents.emit(true);
          this.changeDetectorRef.detectChanges();
        },
        error: (error: AppErrors) => {
          this.clearOverrideBtnLoading = false;
          this.toastMessageService.showError(error);
          this.changeDetectorRef.detectChanges();
        },
      });
  }

  get ForceStatusReasonFormControl(): UntypedFormControl {
    return this.forceStatusForm.controls
      .status_change_reason as UntypedFormControl;
  }

  get ClearOverrideReasonFormControl(): UntypedFormControl {
    return this.clearOverrideForm.controls
      .override_change_reason as UntypedFormControl;
  }

  get forceStatusModalTitleKey(): string {
    return this.pendingForceStatus === 'SuspendedDueToNonPayment'
      ? 'SUBSCRIPTIONS.FORCE_SUSPEND_TITLE'
      : 'SUBSCRIPTIONS.FORCE_ACTIVATE_TITLE';
  }

  get forceStatusModalInfoKey(): string {
    return this.pendingForceStatus === 'SuspendedDueToNonPayment'
      ? 'SUBSCRIPTIONS.FORCE_SUSPEND_INFO'
      : 'SUBSCRIPTIONS.FORCE_ACTIVATE_INFO';
  }

  CanSendCollectionDuesLink(status: string) {
    const subscrptionStatus =
      SubscriptionStatus[status as keyof typeof SubscriptionStatus];
    return (
      subscrptionStatus == SubscriptionStatus.Future ||
      subscrptionStatus == SubscriptionStatus.Active ||
      subscrptionStatus == SubscriptionStatus.Frozen ||
      subscrptionStatus == SubscriptionStatus.SuspendedDueToNonPayment ||
      subscrptionStatus == SubscriptionStatus.PendingForMandatoryAction ||
      subscrptionStatus == SubscriptionStatus.PendingForPaymentConfirmation ||
      subscrptionStatus == SubscriptionStatus.NotRenewing
    );
  }

  SendLinkCollectDuesClick() {
    this.sendLinkCollectDues = true;
  }

  funSendCollectDuesLink(event: Event) {
    this.btnLoading = true;
    const selectedChannels: NotificationChannels[] = [];

    if (this.emailSelected) {
      selectedChannels.push(NotificationChannels.Email);
    }
    if (this.smsSelected) {
      selectedChannels.push(NotificationChannels.SMS);
    }
    if (this.whatsappSelected) {
      selectedChannels.push(NotificationChannels.WhatsApp);
    }
    if (this.mobileNotificationSelected) {
      selectedChannels.push(NotificationChannels.Push);
    }

    if (selectedChannels.length == 0) {
      this.translate
        .get('SUBSCRIPTIONS.MSG.SUBSCRIPTION_CHANNEL_NOTSELECTED')
        .subscribe((translation) => {
          this.toastMessageService.showErrorMessage(translation);
        });
      this.btnLoading = false;
      return;
    }

    const subscription = this.subscription();
    if (subscription) {
      const service = this.subscriptionService.ClientSubscriptionSendManageLink(
        subscription.tenant_id,
        this.clientId(),
        subscription.id,
        selectedChannels,
      );

      service.subscribe({
        next: (data: any) => {
          // Handle array response with success/error per channel
          if (Array.isArray(data)) {
            this.handleMultiChannelResponse(data);
          } else {
            // Fallback for non-array response
            this.translate
              .get('SUBSCRIPTIONS.MSG.SUBSCRIPTION_SEND_MANAGELINK')
              .subscribe((translation) => {
                this.toastMessageService.showSuccess(translation);
              });
          }

          // Reset selections
          this.emailSelected = false;
          this.smsSelected = false;
          this.whatsappSelected = false;
          this.mobileNotificationSelected = false;
          this.sendLinkCollectDues = false;
          this.btnLoading = false;
          this.changeDetectorRef.detectChanges();
        },
        error: (error: AppErrors) => {
          // Handle 409 Conflict or other errors
          if (
            error.originalError?.status === 409 &&
            Array.isArray(error.originalError?.error)
          ) {
            this.handleMultiChannelResponse(error.originalError.error);

            // Reset selections even on partial success
            this.emailSelected = false;
            this.smsSelected = false;
            this.whatsappSelected = false;
            this.mobileNotificationSelected = false;
            this.sendLinkCollectDues = false;
          } else {
            this.toastMessageService.showError(error);
          }
          this.btnLoading = false;
          this.changeDetectorRef.detectChanges();
        },
      });
    }
  }

  private handleMultiChannelResponse(responses: any[]) {
    const successChannels: string[] = [];
    const failedChannels: { channel: string; error: string }[] = [];

    // Categorize responses
    responses.forEach((response) => {
      if (response.success) {
        successChannels.push(response.channel);
      } else {
        failedChannels.push({
          channel: response.channel,
          error: response.error?.errorMessage || 'Unknown error',
        });
      }
    });

    // Show success message if any channels succeeded
    if (successChannels.length > 0) {
      const channelList = successChannels.join(', ');
      this.translate
        .get('SUBSCRIPTIONS.MSG.SUBSCRIPTION_SEND_MANAGELINK_SUCCESS', {
          channels: channelList,
        })
        .subscribe((translation) => {
          this.toastMessageService.showSuccess(translation);
        });
    }

    // Show error message for failed channels
    if (failedChannels.length > 0) {
      failedChannels.forEach((failed) => {
        this.translate
          .get('SUBSCRIPTIONS.MSG.SUBSCRIPTION_SEND_MANAGELINK_FAILED', {
            channel: failed.channel,
            error: failed.error,
          })
          .subscribe((translation) => {
            this.toastMessageService.showErrorMessage(translation);
          });
      });
    }

    // If all failed, show general error
    if (successChannels.length === 0 && failedChannels.length > 0) {
      this.translate
        .get('SUBSCRIPTIONS.MSG.SUBSCRIPTION_SEND_MANAGELINK_ALL_FAILED')
        .subscribe((translation) => {
          this.toastMessageService.showWarning(translation);
        });
    }
  }

  getTrackMode() {
    let modeText = '';
    const trackMode = this.trackMode();
    if (
      trackMode == TrackMode.ClientPurchasePortal ||
      trackMode.toString() == TrackMode[TrackMode.ClientPurchasePortal]
    ) {
      this.translate
        .get('SUBSCRIPTIONS.TRACK_MODE_PP')
        .subscribe((translations: any) => {
          modeText = translations;
        });
    } else if (
      trackMode == TrackMode.ClientMobileApp ||
      trackMode.toString() == TrackMode[TrackMode.ClientMobileApp]
    ) {
      this.translate
        .get('SUBSCRIPTIONS.TRACK_MODE_APP')
        .subscribe((translations: any) => {
          modeText = translations;
        });
    } else {
      modeText = '';
    }
    return modeText;
  }

  // Add Member to Subscription methods
  showAddMemberToSubscription() {
    this.showAddMemberModal = true;
    this.selectedFamilyMember = null;
    this.addMemberForm.reset();
  }

  onFamilyMemberSelected(client: any) {
    this.selectedFamilyMember = client;
    this.addMemberForm.patchValue({
      member_id: client.clt_id,
    });
  }

  onFamilyMemberRemoved(event: any) {
    this.selectedFamilyMember = null;
    this.addMemberForm.reset();
    this.emitEvents.emit(event);
  }

  addMemberToSubscription() {
    if (this.addMemberForm.valid && this.selectedFamilyMember) {
      this.addMemberLoading = true;

      const subscription = this.subscription();
      const familyMemberRequest = {
        parent_subscription_id: this.subscriptionId(),
        child_client_id: this.selectedFamilyMember.clt_id,
        company_id: subscription?.company_id,
        tenant_id: subscription?.tenant_id,
        notes: '',
      };

      this.subscriptionService
        .addFamilyMemberToSubscription(
          this.tenantId(),
          this.clientId(),
          this.subscriptionId(),
          familyMemberRequest,
        )
        .subscribe({
          next: () => {
            this.translate
              .get('SUBSCRIPTIONS.MSG.FAMILY_MEMBER_ADDED_SUCCESS')
              .subscribe((translation) => {
                this.toastMessageService.showSuccess(translation);
              });
            this.addMemberLoading = false;
            this.showAddMemberModal = false;
            this.emitEvents.emit(true);
            this.changeDetectorRef.detectChanges();
          },
          error: (error: AppErrors) => {
            this.addMemberLoading = false;
            this.toastMessageService.showError(error);
            this.changeDetectorRef.detectChanges();
          },
        });
    } else {
      Object.keys(this.addMemberForm.controls).forEach((field) => {
        const control = this.addMemberForm.get(field);
        control?.markAsTouched({ onlySelf: true });
      });
    }
  }

  closeAddMemberModal() {
    this.showAddMemberModal = false;
    this.selectedFamilyMember = null;
    this.addMemberForm.reset();
  }

  get MemberIdFormControl(): UntypedFormControl {
    return this.addMemberForm.controls.member_id as UntypedFormControl;
  }

  canPatchSubscription(subscription: SubscriptionById | null | undefined): boolean {
    if (!subscription) {
      return false;
    }
    return SubscriptionPatchComponent.canPatchSubscription(subscription.status);
  }

  openPatchSubscriptionModal(): void {
    this.showPatchSubscriptionModal = true;
    this.changeDetectorRef.detectChanges();
  }

  closePatchSubscriptionModal(reloadData: boolean): void {
    this.showPatchSubscriptionModal = false;
    if (reloadData) {
      this.emitEvents.emit(true);
    }
    this.changeDetectorRef.detectChanges();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
